import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { useQuery, useQueryClient } from 'react-query';
import axiosClient from '../../../../../../lib/axios';
import { useMemo, useState } from 'react';
import { useSnackbar } from 'notistack';
interface Props {
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

interface FormData {
  nome: string;
  categoria_id?: number | '';
  atributos: any[];
  ordem: any[];
}

export default function DialogCadastrarCategoria({
  open,
  onClose,
  onSuccess,
}: Props) {
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();
  const [formData, setFormData] = useState<FormData>({
    nome: '',
    categoria_id: '',
    atributos: [],
    ordem: []
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (
    e: React.ChangeEvent<{ name?: string; value: unknown }> |
      (Event & { target: { value: number; name: string } })
  ) => {
    const { name, value } = e.target as HTMLInputElement;
    setFormData(prev => ({
      ...prev,
      [name as string]: value
    }));
  };

  const handleSubmit = async () => {
    try {
      setIsSubmitting(true);
      const payload = { ...formData };
      if (payload.categoria_id === '') {
        delete payload.categoria_id;
      }

      await axiosClient.post('/estoque/categoria/cadastrar', payload);

      enqueueSnackbar('Categoria cadastrada com sucesso!', { variant: 'success' });
      setFormData({
        nome: '',
        categoria_id: '',
        atributos: [],
        ordem: []
      });
      onClose();
      await queryClient.invalidateQueries('categorias-mae');
      onSuccess();
    } catch (error) {
      console.error('Erro ao cadastrar categoria:', error);
      enqueueSnackbar('Erro ao cadastrar categoria', { variant: 'error' });
    } finally {
      setIsSubmitting(false);
    }
  };




  const fetchCategorias = async () => {
    const response = await axiosClient.get('/estoque/categoria/listar-todas');
    return response.data;
  };

  const useCategorias = () => {
    return useQuery(['categorias-mae'], fetchCategorias);
  };

  const categoriasQuery = useCategorias();
  const categorias = useMemo(() => categoriasQuery.data?.data || [], [categoriasQuery.data]);


  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Cadastrar Categoria</DialogTitle>
      <DialogContent>
        <TextField
          name="nome"
          label="Nome"
          fullWidth
          margin="normal"
          value={formData.nome}
          onChange={handleChange}
          required
        />

        <FormControl fullWidth margin="normal">
          <InputLabel id="categoria-mae-label">Categoria Mãe (Opcional)</InputLabel>
          <Select
            name="categoria_id"
            labelId="categoria-mae-label"
            label="Categoria Mãe (Opcional)"
            value={formData.categoria_id}
            onChange={handleChange}
          >
            <MenuItem value="">
              <em>Nenhuma</em>
            </MenuItem>
            {categorias.map((categoria: any) => (
              <MenuItem key={categoria.id} value={categoria.id}>
                {categoria.nome}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isSubmitting}>Cancelar</Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={!formData.nome || isSubmitting}
        >
          {isSubmitting ? 'Cadastrando...' : 'Cadastrar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}